module.exports = __webpack_public_path__ + "static/img/zz_jg.bc74c4ea.png";